import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";

export default function Appointment() {
  return (
    <div data-testid="appointment-page" className="pt-28 sm:pt-36">
      <SEO title="Book a Jewellery Appointment — Meerut Showroom"
        description="Book an appointment at the Ramesh Kapoor and Sons Jewellers retail showroom in Meerut." />
      <section className="max-w-[900px] mx-auto px-5 sm:px-8 pb-28">
        <Reveal>
          <Eyebrow>Retail Showroom — Meerut</Eyebrow>
          <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4">
            Book a Jewellery <span className="italic text-[#C5A059]">Appointment</span>
          </h1>
          <p className="text-base text-[#94A3B8] leading-loose mt-6 max-w-2xl">
            Tell us the occasion, budget, and what you are looking for. We prepare a selection before you arrive.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mt-12 border border-white/10 bg-[#0B1320] p-8 sm:p-12">
          <EnquiryForm
            type="retail_appointment"
            fields={[
              { name: "occasion", label: "Occasion", type: "select", required: true,
                options: ["Wedding", "Engagement", "Anniversary", "Festival", "Gifting", "Personal Purchase", "Gold or Silver Coins"] },
              { name: "budget", label: "Budget", placeholder: "e.g. ₹1–3 lakh" },
              { name: "category", label: "Jewellery category", placeholder: "e.g. bridal set, bangles" },
              { name: "metal", label: "Preferred metal", type: "select", options: ["Gold", "Diamond", "Silver", "Not sure yet"] },
              { name: "weight_range", label: "Preferred weight range", placeholder: "e.g. 20–40 g" },
              { name: "visitors", label: "Number of visitors", type: "number" },
              { name: "visit_date", label: "Visit date", type: "date", required: true },
              { name: "visit_time", label: "Visit time", type: "time", required: true },
              { name: "requirement", label: "Additional requirement", type: "textarea", wide: true },
            ]}
          />
        </Reveal>
      </section>
    </div>
  );
}
